<template>
    <div class="block-editor send-transcript">
        <div class="wrapper">
            <div class="title">Email</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="Type your email or use attribute"
                    :show-attributes="true"
                    :show-emoji="false"
                    :max-character-count="200"
                    v-model="clone.email"
                />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

const log = log2("SendTranscript");
export default {
    name: "SendTranscript",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-transcript {
    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
